import React, { useState, useRef } from "react";
import { Icon } from "antd";
import { useTranslation } from "react-i18next";
import ScreenAdItem from "./ScreenAdItem";
import { buildScreenGroups } from "../../utils/screenAdsData";
import ListPagination, { getPageItems, getLastPage } from "../../../../shared/components/ListPagination";

const SCREENS_PAGE_SIZE = 50;

const ScreenAdsCard = ({ campaign, mode, reportSingleData, loadingSingleReport, user }) => {
  const { t } = useTranslation();
  const [open, setOpen] = useState(true);
  const [page, setPage] = useState(1);
  const cardRef = useRef(null);
  const groups = buildScreenGroups(campaign);
  const isProposal = mode === "proposal";

  if (groups.length === 0) return null;

  const currentPage = Math.min(page, getLastPage(groups.length, SCREENS_PAGE_SIZE));

  const changePage = (newPage) => {
    setPage(newPage);
    if (cardRef.current) cardRef.current.scrollIntoView({ block: "start" });
  };

  return (
    <div className="campaignDetail__card screenAds__card" ref={cardRef}>
      <div className="campaignDetail__section-head">
        <div className="campaignDetail__section-title campaignDetail__map-title">
          {isProposal ? t("Screens") : t("Ads per screen")}
        </div>
        <button type="button" className="campaignDetail__toggle" onClick={() => setOpen(!open)}>
          {open ? t("Hide") : t("Show")} <Icon type={open ? "up" : "down"} />
        </button>
      </div>
      {open && (
      <>
      <div className="screenAds__list">
        {getPageItems(groups, currentPage, SCREENS_PAGE_SIZE).map((group) => (
          <ScreenAdItem
            key={group.screen.display_id}
            group={group}
            campaign={campaign}
            mode={mode}
            reportSingleData={reportSingleData}
            loadingSingleReport={loadingSingleReport}
            user={user}
          />
        ))}
      </div>
      <ListPagination
        className="screenAds__pagination"
        total={groups.length}
        pageSize={SCREENS_PAGE_SIZE}
        current={currentPage}
        onChange={changePage}
        labelKey="Showing {{shown}} of {{total}} screens"
      />
      </>
      )}
    </div>
  );
};

export default ScreenAdsCard;
